var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-container',{staticClass:"container home-content"},[_c('survey',{attrs:{"survey":_vm.survey}}),(_vm.displayButton)?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.onSubmit}},[_c('b-icon-check-circle-fill'),_vm._v(" Next ")],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }